import { createFilterOptions } from '@mui/material';
import React from 'react';
import { LoadState } from '../../../types/LoadState';
import { VarderingarAutocomplete } from './VarderingarAutocomplete';

interface KommunerAutocompleteProps {
  loadState: LoadState;
  kommuner: string[];
  inputValue: string;
  setInputValue: (value: string) => void;
  selectedValue: string;
  setSelectedValue: (value: string) => void;
}

export const KommunerAutocomplete: React.FC<KommunerAutocompleteProps> = ({
  loadState,
  kommuner,
  inputValue,
  setInputValue,
  selectedValue,
  setSelectedValue,
}) => (
  <VarderingarAutocomplete
    disabled={loadState !== LoadState.Success}
    options={kommuner}
    forcePopupIcon={false}
    filterOptions={createFilterOptions({ matchFrom: 'start' })}
    inputValue={inputValue}
    onInputChange={(_e, newKommunValue) => setInputValue(newKommunValue)}
    value={selectedValue}
    onChange={(_e, value) => setSelectedValue(value)}
    loadState={loadState}
    label="Kommun"
    sx={{ width: 180 }}
    freeSolo={false}
  />
);
